import { useThemeColor } from "@tennr/frontend/hooks/useThemeColor";

/**
 * Component that syncs theme color with Safari status bar
 * Must be rendered inside BackgroundColorProvider
 */
export function ThemeColorSync() {
  useThemeColor();
  return null;
}